import React from "react";
import Header from "../components/header/Header";
import Contents from "../components/pages/joinAttorney/Contents";

const JoinAttorney = () => {
  return (
    <>
      <Header />
      <Contents />
    </>
  );
};

export default JoinAttorney;
